module.exports = __webpack_public_path__ + "static/media/image_5.3f4ff6c5.jpg";